import {
    afterNextRender,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { theme } from '../../../../_constants/appSetting.constant';
import { chartColors } from '../../../../_constants/chart-colors';
import { Subscription } from 'rxjs';

Chart.register(ArcElement, Tooltip, Legend);

@Component({
    selector: 'lokos-radial-bar-chart',
    templateUrl: './radial-bar-chart.component.html',
    styleUrl: './radial-bar-chart.component.scss',
    standalone: false
})
export class RadialBarChartComponent implements OnChanges, OnDestroy {
  @Input() chartDetails!: any;
  chart: any;
  @ViewChild('masterChart') private masterChart!: ElementRef<HTMLCanvasElement>;
  labelColor: any;
  subscriptions: Subscription[] = [];
  constructor(private _app: AppSettingService) {
      afterNextRender(() => {
          const currentTheme = this._app.appTheme$.subscribe((currentTheme) => {
              this.labelColor =
          currentTheme === theme.LIGHT
              ? chartColors.lightTheme
              : chartColors.darkTheme;
              this.createChart();
          });
          this.subscriptions.push(currentTheme);
          this.createChart();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (
          changes?.['chartDetails']?.currentValue !==
      changes?.['chartDetails']?.previousValue
      ) {
          this.createChart();
      }
  }

  createChart() {
      const ctx = this.masterChart?.nativeElement.getContext('2d');

      if (!ctx) {
          console.error('Canvas context is not available!');
          return;
      }

      // Apply gradient background logic if needed
      if (this.chartDetails?.isGradient) {
          const gradient: CanvasGradient[] = [];
          this.chartDetails.data?.datasets.forEach(
              (dataset: { backgroundColor: any }, index: number) => {
                  const grad = ctx.createLinearGradient(
                      0,
                      0,
                      0,
                      this.chartDetails?.gradientFade || 100
                  );
                  grad.addColorStop(1, this.chartDetails?.gradientColor[0]);
                  grad.addColorStop(0, this.chartDetails?.gradientColor[index + 1]);
                  gradient.push(grad);
                  dataset.backgroundColor = gradient[index];
              }
          );
      }

      // Destroy existing chart instance if any
      if (this.chart) {
          this.chart.destroy();
      }

      // Initialize the chart
      this.chart = new Chart(ctx, {
          type: this.chartDetails?.type || 'doughnut',
          data: {
              labels: this.chartDetails.data?.labels || [],
              datasets: this.chartDetails?.data.datasets || []
          },
          options: this.chartDetails?.options || {},
          plugins: this.chartDetails?.plugins || []
      });
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach((sub: Subscription) => {
          sub.unsubscribe();
      });
  }
}
